import { render } from "./profileNavComponent.vue?vue&type=template&id=02a92628&scoped=true"
import script from "./profileNavComponent.vue?vue&type=script&lang=js"
export * from "./profileNavComponent.vue?vue&type=script&lang=js"

import "./profileNavComponent.vue?vue&type=style&index=0&id=02a92628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a92628"]])

export default __exports__